export default "__VITE_ASSET__CB3XDX78__"